import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import ProteinComponent from '@/components/ProteinComponent'
import Structures from '@/components/Structures'
import Summary from '@/components/Summary'
import Peptides from '@/components/Peptides'
import Mutations from '@/components/Mutations'
import Modifications from '@/components/ModificationsComponent'
import DynaminePredictions from '@/components/DynamineComponent'
import Projects from '@/components/ProjectsComponent'
import { publicPath } from '../../vue.config.js'

Vue.use(Router)

const NotFound = { template: '<div>404: Page not found</div>' }

export default new Router({
    mode: 'history', // TODO need to enable for prod, but need to configure server
    base: publicPath,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/:protein',
            component: ProteinComponent,
            children: [
                {
                    path: '',
                    redirect: 'summary'
                },
                {
                    path: 'summary',
                    name: 'summary',
                    component: Summary,
                    props: true
                },
                {
                    path: 'structures',
                    name: 'structures',
                    component: Structures
                },
                {
                    path: 'peptides',
                    name: 'peptides',
                    component: Peptides
                },
                {
                    path: 'modifications',
                    name: 'modifications',
                    component: Modifications
                },
                {
                    path: 'projects',
                    name: 'projects',
                    component: Projects,
                    // children: [
                    //     {
                    //         path:'/:project',
                    //         name: 'project',
                    //         // beforeEnter: (to, from, next) => {
                    //         //     console.log('beforeEnter')
                    //         //     next(false)
                    //         // }
                    //     }
                    // ]
                },
                {
                    path: 'mutations',
                    name: 'mutations',
                    component: Mutations
                },
                {
                    path: 'dynamic-properties',
                    name: 'dynamic',
                    component: DynaminePredictions
                },
            ]
        },
        {
            path: '*',
            component: NotFound
        }
        // {
        //     path: '/:proteinId',
        //     name: 'protein',
        //     redirect: 'summary',
        //     children: [

        //     ]
        // },
    ]
})
